import { Badge } from "../ui/Badge";

type CheckoutStatus =
  | "PENDING"
  | "APPROVED"
  | "CANCELLED"
  | "PARTIAL"
  | "MIXED"
  | "COMPLETE";

function getVariant(
  status: CheckoutStatus,
): "warning" | "success" | "info" {
  switch (status) {
    case "PENDING":
    case "MIXED":
      return "warning";
    case "APPROVED":
    case "COMPLETE":
      return "success";
    case "CANCELLED":
    case "PARTIAL":
      return "info";
  }
}

export function CheckoutStatusBadge({ status }: { status: CheckoutStatus }) {
  return (
    <Badge variant={getVariant(status)} size="sm">
      {status}
    </Badge>
  );
}
